export default "__VITE_ASSET__d21a9649__"